"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Copy = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const Copy = ({ fill = "#E6E6E6", size = 16 }) => (react_1.default.createElement(Base_1.Base, { size: size, smooth: true },
    react_1.default.createElement("path", { fill: "none", d: "M16,16H0V0h16V16z" }),
    react_1.default.createElement("path", { fill: fill, d: "M5,4H0v12h9V8L5,4z M4,9V5l4,4H4z" }),
    react_1.default.createElement("path", { fill: fill, d: "M16,1v3v2v6h-5V7.2l-4-4V1h2v3h1h3h1V1H16z" }),
    react_1.default.createElement("path", { fill: fill, d: "M13,1v2h-3V1h1V0h1v1H13z" })));
exports.Copy = Copy;
//# sourceMappingURL=Copy.js.map